// Keeps an element in view while the page above it is still loading (sections arriving push it down); stops when the reader scrolls.
export const scrollWhenSettled = (selector, ms = 4000) => {
  let stop = false;
  const go = () => !stop && document.querySelector(selector)?.scrollIntoView({ block: "start" });
  const end = () => { stop = true; ro.disconnect(); ["wheel", "touchstart", "keydown"].forEach((e) => window.removeEventListener(e, end)); };
  const ro = new ResizeObserver(go);
  ro.observe(document.body);
  ["wheel", "touchstart", "keydown"].forEach((e) => window.addEventListener(e, end, { passive: true }));
  setTimeout(end, ms);
  requestAnimationFrame(go);
  return end;
};
